__webpack_require__.p = "/github-repositories-explorer/";